export const userProfileConstants = {

    // REQUEST BATCH 
    REQUEST_USER_PROFILE: 'REQUEST_USER_PROFILE',
    RECEIVE_USER_PROFILE: 'RECEIVE_USER_PROFILE',
    USER_PROFILE_ERROR: 'USER_PROFILE_ERROR',

    // REQUEST DEMOGRAPHIC DATA 
    REQUEST_DEMOGRAPHIC_DATA: 'REQUEST_DEMOGRAPHIC_DATA',
    RECEIVE_DEMOGRAPHIC_DATA: 'RECEIVE_DEMOGRAPHIC_DATA',
    DEMOGRAPHIC_DATA_ERROR: 'DEMOGRAPHIC_DATA_ERROR',

    // UPDATE_BASIC_PROFILE
    REQUEST_UPDATE_BASIC_PROFILE: 'REQUEST_UPDATE_BASIC_PROFILE',
    RECEIVE_UPDATE_BASIC_PROFILE: 'RECEIVE_UPDATE_BASIC_PROFILE',
    UPDATE_BASIC_PROFILE_ERROR: 'UPDATE_BASIC_PROFILE_ERROR',

    // UPDATE_ACCOUNT_PROFILE
    REQUEST_UPDATE_ACCOUNT_PROFILE: 'REQUEST_UPDATE_ACCOUNT_PROFILE',
    RECEIVE_UPDATE_ACCOUNT_PROFILE: 'RECEIVE_UPDATE_ACCOUNT_PROFILE',
    UPDATE_ACCOUNT_PROFILE_ERROR: 'UPDATE_ACCOUNT_PROFILE_ERROR',

    // UPDATE_ADDITIONAL_INFO
    REQUEST_UPDATE_ADDITIONAL_INFO: 'REQUEST_UPDATE_ADDITIONAL_INFO',
    RECEIVE_UPDATE_ADDITIONAL_INFO: 'RECEIVE_UPDATE_ADDITIONAL_INFO',
    UPDATE_ADDITIONAL_INFO_ERROR: 'UPDATE_ADDITIONAL_INFO_ERROR',

    // UPDATE_DOB
    REQUEST_UPDATE_DOB: 'REQUEST_UPDATE_DOB',
    RECEIVE_UPDATE_DOB: 'RECEIVE_UPDATE_DOB',
    UPDATE_DOB_ERROR: 'UPDATE_DOB_ERROR',

    // CHANGE_PASSWORD
    REQUEST_CHANGE_PASSWORD: 'REQUEST_CHANGE_PASSWORD',
    RECEIVE_CHANGE_PASSWORD: 'RECEIVE_CHANGE_PASSWORD',
    CHANGE_PASSWORD_ERROR: 'CHANGE_PASSWORD_ERROR',

    // SET_PASSWORD
    REQUEST_SET_PASSWORD: 'REQUEST_SET_PASSWORD',
    RECEIVE_SET_PASSWORD: 'RECEIVE_SET_PASSWORD',
    SET_PASSWORD_ERROR: 'SET_PASSWORD_ERROR',

    //REQUEST_FORGOT_PASSWORD
    REQUEST_FORGOT_PASSWORD: 'REQUEST_FORGOT_PASSWORD',
    RECEIVE_FORGOT_PASSWORD: 'RECEIVE_FORGOT_PASSWORD',
    FORGOT_PASSWORD_ERROR: 'FORGOT_PASSWORD_ERROR',

    // REQUEST_CREATE_PROFILE
    REQUEST_CREATE_PROFILE: 'REQUEST_CREATE_PROFILE',
    RECEIVE_CREATE_PROFILE: 'RECEIVE_CREATE_PROFILE',
    CREATE_PROFILE_ERROR: 'CREATE_PROFILE_ERROR',

    // REQUEST_SIGNUP_COMPLETED
    REQUEST_SIGNUP_COMPLETED: 'REQUEST_SIGNUP_COMPLETED',
    RECEIVE_SIGNUP_COMPLETED: 'RECEIVE_SIGNUP_COMPLETED',
};



// WEBPACK FOOTER //
// ./src/_constants/userProfile.constants.js